import Facility from '@/models/Facility'
import User, { hasRole, Role } from '@/models/User'

export default class FacilityPolicy {
	viewAny(_user: User): boolean {
		return false
	}

	view(user: User, facility: Facility): boolean {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === facility.company.id
			case Role.AUDITOR:
				return facility.company.auditors?.some((auditor) => auditor.id === user.auditor?.id) ?? false
			default:
				return false
		}
	}

	create(user: User): boolean {
		return hasRole(user, Role.USER)
	}

	update(user: User, facility: Facility): boolean {
		return hasRole(user, Role.USER) && user.company?.id === facility.company.id
	}

	restore(user: User, facility: Facility): boolean {
		return hasRole(user, Role.USER) && user.company?.id === facility.company.id
	}

	delete(user: User, facility: Facility): boolean {
		return hasRole(user, Role.USER) && user.company?.id === facility.company.id
	}

	forceDelete(_user: User, _facility: Facility): boolean {
		return false
	}
}
